import React, { useState, useEffect, useRef } from 'react';
import { ShimmerCircularImage, ShimmerThumbnail } from 'react-shimmer-effects';

// Cache to store loaded images
const loadedImages = new Set();

const ShimmerImage = ({ src, alt, width = 50, height = 50, className = '' }) => {
    const [isLoading, setIsLoading] = useState(!loadedImages.has(src));
    const imageRef = useRef(null);

    useEffect(() => {
        if (!src) return;

        // If image is already loaded, don't show loading state
        if (loadedImages.has(src)) {
            setIsLoading(false);
            return;
        }

        // Check if image is already in browser cache
        const img = new Image();
        img.src = src;

        if (img.complete) {
            loadedImages.add(src);
            setIsLoading(false);
        }
    }, [src]);

    const handleLoad = () => {
        loadedImages.add(src);
        setIsLoading(false);
    };

    const handleError = () => {
        setIsLoading(false);
    };

    return (
        <>
            {isLoading && (
                <ShimmerCircularImage 
                    size={width}
                />
            )}
            <img 
                ref={imageRef}
                className={className}
                style={{ 
                    display: isLoading ? 'none' : 'block'
                }}
                src={src}
                alt={alt}
                onLoad={handleLoad}
                onError={handleError}
            />
        </>
    );
};

export default ShimmerImage;

export const ShimmerThumbnailImage = ({ src, alt, width = '', height = '', className = '' }) => {
    const [isLoading, setIsLoading] = useState(!loadedImages.has(src));
    const imageRef = useRef(null);

    useEffect(() => {
        if (!src) return;

        // If image is already loaded, don't show loading state
        if (loadedImages.has(src)) {
            setIsLoading(false);
            return;
        }

        // Check if image is already in browser cache
        const img = new Image();
        img.src = src;

        if (img.complete) {
            loadedImages.add(src);
            setIsLoading(false);
        }
    }, [src]);

    const handleLoad = () => {
        loadedImages.add(src);
        setIsLoading(false);
    };

    const handleError = () => {
        setIsLoading(false);
    };

    return (
        <>
            {isLoading && (
                <ShimmerThumbnail 
                    height={height}
                    width={width}
                />
            )}
            <img 
                ref={imageRef}
                className={className}
                style={{ 
                    display: isLoading ? 'none' : 'block'
                }}
                src={src}
                alt={alt}
                onLoad={handleLoad}
                onError={handleError}
            />
        </>
    );
};
